"use client";

import { c as _c } from "react/compiler-runtime";
import { Close, FullScreen } from "@icon-park/svg";
import { Icon, Modal } from "@justhome/react-ui";
import { type ReactNode, useCallback, useRef, useState, useSyncExternalStore } from "react";

// The sticky cells use z-10 to z-30; isolating the scroller keeps them below the sticky site header.
// Overscroll is contained sideways only, or a table without vertical overflow swallows the page's wheel.
const SCROLLER = "isolate overflow-auto overscroll-x-contain rounded-2xs focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-800";
const overflows = (element: HTMLElement | null) => !!element && (element.scrollWidth > element.clientWidth + 1 || element.scrollHeight > element.clientHeight + 1);
const TableFrame = t0 => {
  const $ = _c(28);
  const {
    label,
    labels,
    children
  } = t0;
  const scroller = useRef(null);
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = onChange => {
      const observer = new ResizeObserver(onChange);
      if (scroller.current) {
        observer.observe(scroller.current);
      }
      return () => observer.disconnect();
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const subscribe = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => overflows(scroller.current);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const scrollable = useSyncExternalStore(subscribe, t2, _temp);
  let t3;
  if ($[2] !== children || $[3] !== label) {
    t3 = <div ref={scroller} className={`${SCROLLER} max-h-[75vh]`} tabIndex={0} role="region" aria-label={label}>{children}</div>;
    $[2] = children;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== labels.fullscreen || $[6] !== scrollable) {
    t4 = scrollable && <button type="button" onClick={() => setOpen(true)} data-tracking-event="Article - Table Fullscreen" className="hidden m:[@media(hover:hover)]:inline-flex absolute top-2xs right-2xs z-10 items-center gap-3xs px-2xs py-[6px] rounded-full bg-neutral-0 shadow-4 border-none cursor-pointer text-body-2 font-semibold text-neutral-675 hover:text-primary-800 opacity-0 group-hover:opacity-100 focus-visible:opacity-100 transition-opacity focusable"><Icon icon={FullScreen} size={16} className="flex" />{labels.fullscreen}</button>;
    $[5] = labels.fullscreen;
    $[6] = scrollable;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== label) {
    t5 = <Modal.Title className="text-title-1 font-semibold text-neutral-675 m-none">{label}</Modal.Title>;
    $[8] = label;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpen(false);
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon icon={Close} size={20} className="flex" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== labels.close) {
    t8 = <button type="button" onClick={t6} aria-label={labels.close} className="flex p-3xs -m-3xs bg-transparent border-none cursor-pointer text-neutral-425 hover:text-primary-800 focusable">{t7}</button>;
    $[12] = labels.close;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <div className="flex items-center justify-between gap-s">{t5}{t8}</div>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== children || $[18] !== label) {
    t10 = <div className={`${SCROLLER} bg-neutral-12 max-h-[calc(100vh-176px)]`} tabIndex={0} role="region" aria-label={label}>{children}</div>;
    $[17] = children;
    $[18] = label;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== open || $[21] !== t10 || $[22] !== t9) {
    t11 = <Modal isOpen={open} setIsOpen={setOpen} maxWidth="calc(100vw - 32px)">{t9}{t10}</Modal>;
    $[20] = open;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t3 || $[26] !== t4) {
    t12 = <div className="group relative bg-neutral-12 rounded-2xs">{t3}{t4}{t11}</div>;
    $[24] = t11;
    $[25] = t3;
    $[26] = t4;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
export default TableFrame;
function _temp() {
  return false;
}